const DEFAULTS = {
  MARKET: "https://int3.hoistfinance.fr",
  LOCALE: '/',
  SECONDARY_LOCALE: 'en',
  HOST_TYPE: "Primary",
  PAGE_TYPE: "Page",
};

export default DEFAULTS;
